namespace RioERP.Users {
    export interface CustomerAddressRow {
        Id?: number;
        CustomerId?: number;
        Address1?: string;
        Address2?: string;
        City?: string;
        StateId?: number;
        Country?: string;
        IsActive?: boolean;
        PinCode?: string;
        StateName?: string;
        CustomerName?: string;
        CustomerEmailId1?: string;
        CustomerEmailId2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        CustomerIsActive?: boolean;
        CustomerInsertUserId?: number;
        CustomerInsertDate?: string;
        CustomerUpdateUserId?: number;
        CustomerUpdateDate?: string;
        CustomerECustomerType?: number;
        CustomerGstin?: string;
        CustomerCouponCode?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace CustomerAddressRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Address1';
        export const localTextPrefix = 'Users.CustomerAddress';
        export const deletePermission = 'Users:UsersManagement:Modify';
        export const insertPermission = 'Users:UsersManagement:Modify';
        export const readPermission = 'Users:UsersManagement:View';
        export const updatePermission = 'Users:UsersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            CustomerId = "CustomerId",
            Address1 = "Address1",
            Address2 = "Address2",
            City = "City",
            StateId = "StateId",
            Country = "Country",
            IsActive = "IsActive",
            PinCode = "PinCode",
            StateName = "StateName",
            CustomerName = "CustomerName",
            CustomerEmailId1 = "CustomerEmailId1",
            CustomerEmailId2 = "CustomerEmailId2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            CustomerIsActive = "CustomerIsActive",
            CustomerInsertUserId = "CustomerInsertUserId",
            CustomerInsertDate = "CustomerInsertDate",
            CustomerUpdateUserId = "CustomerUpdateUserId",
            CustomerUpdateDate = "CustomerUpdateDate",
            CustomerECustomerType = "CustomerECustomerType",
            CustomerGstin = "CustomerGstin",
            CustomerCouponCode = "CustomerCouponCode",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
